import { useMicrocopy } from "@/lib/contentful/microcopy/microcopy-context";
import { DateTime, Grid, GridItem, Heading, Text, VStack } from "@project/ui";
import type { DriverFieldsFragment } from "@/lib/contentful/__generated/graphql.types";
import { AnimatingWrapper } from "@/components/animating-wrapper";

type DriverHeaderDetailsProps = DriverFieldsFragment;

export const DriverHeaderDetails = (props: DriverHeaderDetailsProps) => {
    const { dateOfBirth, placeOfBirth, height, weight, series } = props;

    const { get: getMicrocopy } = useMicrocopy();

    return (
        <Grid
            templateColumns={{ base: "repeat(2, 1fr)", l: "repeat(6, 1fr)" }}
            color="allWhite"
            py={10}
            gap={6}
        >
            <GridItem colSpan={{ base: 2, l: 4 }}>
                <Grid templateColumns={{ base: "repeat(2, 1fr)", l: "repeat(4, 1fr)" }} gap={6}>
                    {dateOfBirth && (
                        <GridItem colSpan={2}>
                            <AnimatingWrapper delay={1.1}>
                                <VStack align="start" spacing={2}>
                                    <Text size="caption" color="grey600">
                                        {getMicrocopy("pageDriverPage", "label.dateOfBirth")}
                                    </Text>
                                    <DateTime
                                        isHeading={true}
                                        size="headingMedium"
                                        fontWeight="600"
                                    >
                                        {dateOfBirth}
                                    </DateTime>
                                </VStack>
                            </AnimatingWrapper>
                        </GridItem>
                    )}
                    {placeOfBirth && (
                        <GridItem colSpan={2}>
                            <AnimatingWrapper delay={1.2}>
                                <VStack align="start" spacing={2}>
                                    <Text size="caption" color="grey600">
                                        {getMicrocopy("pageDriverPage", "label.placeOfBirth")}
                                    </Text>
                                    <Heading as="p" size="headingMedium" fontWeight="600">
                                        {placeOfBirth}
                                    </Heading>
                                </VStack>
                            </AnimatingWrapper>
                        </GridItem>
                    )}
                    {height && (
                        <GridItem colSpan={2}>
                            <AnimatingWrapper delay={1.3}>
                                <VStack align="start" spacing={2}>
                                    <Text size="caption" color="grey600">
                                        {getMicrocopy("pageDriverPage", "label.height")}
                                    </Text>
                                    <Heading as="p" size="headingMedium" fontWeight="600">
                                        {height}
                                    </Heading>
                                </VStack>
                            </AnimatingWrapper>
                        </GridItem>
                    )}
                    {weight && (
                        <GridItem colSpan={2}>
                            <AnimatingWrapper delay={1.4}>
                                <VStack align="start" spacing={2}>
                                    <Text size="caption" color="grey600">
                                        {getMicrocopy("pageDriverPage", "label.weight")}
                                    </Text>
                                    <Heading as="p" size="headingMedium" fontWeight="600">
                                        {weight}
                                    </Heading>
                                </VStack>
                            </AnimatingWrapper>
                        </GridItem>
                    )}
                </Grid>
            </GridItem>

            {series && (
                <GridItem colSpan={{ base: 2, l: 6 }}>
                    <AnimatingWrapper delay={1.5}>
                        <VStack align="start" spacing={2}>
                            <Text size="caption" color="grey600">
                                {getMicrocopy("pageDriverPage", "label.series")}
                            </Text>

                            <Heading as="p" size="headingMedium" fontWeight="600">
                                {series}
                            </Heading>
                        </VStack>
                    </AnimatingWrapper>
                </GridItem>
            )}
        </Grid>
    );
};
